import { ar, type MessageId } from './ar';
import { en } from './en';

export type { MessageId };
/** اللغتان المدعومتان — والاتجاه لا يتغيّر بينهما (RTL في الحالتين) */
export type Lang = 'ar' | 'en';
export const LANGS: readonly Lang[] = ['ar', 'en'] as const;
export const LANG_STORAGE_KEY = 'rafrafa.lang';

const dicts: Record<Lang, Partial<Record<MessageId, string>>> = { ar, en };

export function isLang(v: unknown): v is Lang {
  return v === 'ar' || v === 'en';
}

/** قيم تُحلّ داخل النص بصيغة {name} */
export type Vars = Record<string, string | number>;

/**
 * عازل اتجاه للنصّ اللاتيني داخل صفحة RTL (LRI … PDI من يونيكود 6.3).
 * الصفحة تبقى RTL والعناصر في مواضعها — لكن كل نصٍّ إنجليزي يصير «مقطعاً
 * معزولاً» ترتيبه LTR، فلا تهاجر النقطة ولا القوسان إلى بداية السطر.
 * بلا هذا العازل تقرأ الجملة الإنجليزية «.the audit log» بالنقطة أولاً.
 */
const LRI = '\u2066';
const PDI = '\u2069';

/**
 * العربية هي المرجع: أي مفتاح ناقص في لغة أخرى يُعاد بنصّه العربي،
 * فلا يظهر معرِّف خام على الشاشة في أي حال.
 */
export function resolve(lang: Lang, id: MessageId, vars?: Vars): string {
  const dict = dicts[lang][id];
  // العربية هي البديل عند غياب المفتاح — وحينها لا يُعزل النصّ لأنه عربي أصلاً
  const raw = dict ?? ar[id];
  const filled = vars
    ? raw.replace(/\{(\w+)\}/g, (m, k: string) => (k in vars ? String(vars[k]) : m))
    : raw;
  return lang === 'en' && dict !== undefined ? LRI + filled + PDI : filled;
}
